var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12",staticStyle:{"position":"relative","bottom":"0px"}},[_c('div',{staticClass:"copyrights text-right"},[_vm._v(" Copyright © 2021 "),_c('a',{staticStyle:{"color":"#000"},attrs:{"href":"https://cogfranquicias.com","target":"_blank","rel":"noopener"}},[_vm._v("COG Franquicias LLC")]),_c('br'),_vm._v(" Todos los derechos reservados. ")])])
}]

export { render, staticRenderFns }